<div class="mb-7 flex gap-5 items-center" (click)="editDetails()">
	<p class="text-xl font-bold truncate">{{ title | capitalize }}</p>
	<div class="flex flex-1 w-full gap-3 text-green cursor-pointer">
		<app-icon [icon]="ICON.EDIT"></app-icon>
		<p class="underline flex-1 w-full whitespace-nowrap">Edit details</p>
	</div>
</div>
<div
	class="flex justify-between"
	*ngIf="
		encumbrance?.action === actionTypes.DISCHARGE ||
		encumbrance?.action === actionTypes.BRIDGE
	"
>
	<app-checkbox
		type="clear"
		[ngModel]="encumbrance?.undertaking"
		(ngModelChange)="setUndertaking($event)"
		>Show as undertaking given</app-checkbox
	>
	<app-checkbox
		type="clear"
		[ngModel]="encumbrance?.fulfilled"
		(ngModelChange)="setFulfilled($event)"
		*ngIf="encumbrance?.undertaking"
		[@fade]
		>Fulfilled</app-checkbox
	>
</div>

<div
	*ngIf="encumbrance?.fulfilled"
	class="flex justify-between mt-2 items-end"
	[@openClose]
>
	<app-input
		type="text"
		label="Discharged by instrument number"
		name="dischargeNumber"
		[ngModel]="encumbrance.dischargedInstrumentNumber"
		(debounce)="setDischargeNumber($event)"
	></app-input>
	<app-date-picker
		label="Registered on date"
		name="registeredOn"
		class="ml-2"
		[ngModel]="encumbrance.registeredOnDate"
		(ngModelChange)="setRegisteredOn($event)"
	></app-date-picker>
</div>

<app-container
	type="dark"
	class="mt-5"
	*ngIf="
		encumbrance?.action !== actionTypes.ASSUME &&
		encumbrance?.action !== actionTypes.REMAIN
	"
>
	<div class="flex justify-between items-center">
		<div class="flex items-center">
			<h4>Payment calculator</h4>
			<app-button
				[icon]="ICON.EDIT"
				class="ml-5"
				btn="tertiary"
				(click)="showPaymentCalculator()"
			></app-button>
		</div>
		<div class="flex flex-col">
			<div class="text-right">
				<span class="font-bold">{{ total?.grandTotal | centsToDollars }}</span>
			</div>
			<div class="text-right text-sm">
				<span *ngIf="!encumbrance?.paymentCalc?.separateCheque"
					>Including discharge fees of</span
				>
				<span *ngIf="encumbrance?.paymentCalc?.separateCheque"
					>Discharge fees of
				</span>
				{{ total?.dischargeFeesTotal | centsToDollars }}
			</div>
			<div
				class="text-right text-sm"
				*ngIf="encumbrance?.paymentCalc?.principalFrom"
			>
				<span>Interest inclusive to</span>
				{{ encumbrance.paymentCalc.principalFrom | date }}
			</div>
		</div>
	</div>
</app-container>

<div class="mt-3">
	<app-mortgagee
		[mortgagee]="encumbrance"
		(onMortgageeUpdated)="updateMortgagee($event)"
		[showDischargeFields]="true"
	></app-mortgagee>
</div>

<app-encumbrance-mortgage-details
	class="flex mt-5"
	[encumbrance]="encumbrance"
	[showPriorityWarning]="showPriorityWarning"
></app-encumbrance-mortgage-details>
